import NotFound from "../components/404";
// Index
import IndexPage from "../components/index.vue";
import RefurbishedBuilds from "../components/store/refurbished-builds/index.vue";
import PCRental from "../components/store/pc-rental/index.vue";
import PCRentalSubscribe from "../components/store/pc-rental/subscribe.vue";
// Index for Influencer
import InfluencerPage from "../components/influencer-page/ninja.vue";
// Index for Landing Pages
import LandingPageTemplate from "../components/landing-pages/landing-page-template.vue";
import NvidiaLandingPage from "../components/landing-pages/nvidia.vue";
import CasePromo from "../components/landing-pages/ninja-promo.vue";
import UnboxPromo from "../components/landing-pages/unbox-promo.vue";
import SamsungBlizzconPromo from "../components/landing-pages/samsung-blizzcon-promo";
import BulkPurchase from "../components/landing-pages/bulk-purchase/index.vue";
// BLD Store
import BuildPc from "../components/store/build/bld.vue";
import BuildAf from "../components/store/build/bld-af.vue";
import BuildPcStep2 from "../components/store/build/step2.vue";
import BuildPcStep3 from "../components/store/build/step-3";
import BuildPcStep4 from "../components/store/build/step-4/step4.vue";
import BuildPcStep4Mobile from "../components/store/build/step4-mobile.vue";
import BuildPcStep5 from "../components/store/build/step-5";
import BuildReviews from "../components/store/reviews.vue";
// Stream Promo
import StreamPromo from "../components/store/promos/stream-dreams-2019/index.vue";
// Static Pages
import Warranty from "../components/static-pages/warranty.vue";
import Returns from "../components/static-pages/returns-and-exchanges.vue";
import Shipping from "../components/static-pages/shipping-and-deliveries.vue";
import WhatIsBld from "../components/landing-pages/what-is-bld";
import BuildIntel from "../components/static-pages/bld-intel.vue";
// Auth
import UserConfig from "../components/user/config.vue";
import UserLogin from "../components/user/login.vue";
import UserSignup from "../components/user/signup.vue";
import UserForgotPass from "../components/user/forgot-password.vue";
import UserResetPass from "../components/user/reset-password.vue";
import UserAccount from "../components/user/user-account.vue";
import UserBuild from "../components/store/build/user-build.vue";
import UserTicketDetails from "../components/user/ticket-details.vue";

import UserTrackingOrder from "../components/user/user-tracking-order.vue";

import Hue2Promo from "../components/landing-pages/hue2-promo.vue";

// Starter PC
import StarterPC from "../components/store/starter-pc/index.vue";
import AccessoriesStore from "../components/store/starter-pc/accessories-store/index.vue";
import StarterPcCart from "../components/store/starter-pc/starter-pc-cart/index.vue";

// Starter PC Series
import StaterLineSeries from "../components/store/prebuild-series/starter-line/index.vue";

// Prebuild Series
import PrebuildAccessoriesStore from "../components/store/prebuild-series/preduild-store/prebuild-accessories-store";
import PrebuildCart from "../components/store/prebuild-series/preduild-store/prebuild-cart";

const routes = [
	{
		path: "/",
		name: "home",
		component: IndexPage
	},
	{
		path: "/promo/:influencer",
		name: "landing-page-template",
		component: LandingPageTemplate,
		meta: {
			disallowInPosMode: true
		}
	},
	{
		path: "/holiday-promo-2019",
		redirect: {
			name: "home"
		}
	},
	{
		path: "/ninja",
		name: "influencer-page-ninja",
		component: InfluencerPage,
		meta: {
			disallowInPosMode: true
		}
	},
	{
		path: "/ninja-promo",
		name: "case-promo-ninja",
		component: CasePromo,
		meta: {
			disallowInPosMode: true
		}
	},
	{
		path: "/unbox-promo",
		name: "case-promo-unbox",
		component: UnboxPromo,
		meta: {
			disallowInPosMode: true
		}
	},
	{
		path: "/samsung-blizzcon-promo",
		name: "case-promo-samsung",
		component: SamsungBlizzconPromo,
		meta: {
			disallowInPosMode: true
		}
	},
	{
		path: "/bulk-purchase",
		name: "bulk-purchase",
		component: BulkPurchase
	},
	{
		path: "/pubg",
		name: "case-promo-pubg",
		component: LandingPageTemplate,
		meta: {
			disallowInPosMode: true,
			influencer: "pubg"
		}
	},
	{
		path: "/gamer-day",
		name: "gamer-day-promo",
		component: LandingPageTemplate,
		meta: {
			disallowInPosMode: true,
			influencer: "gamer-day"
		}
	},
	{
		path: "/nvidia",
		name: "case-promo-nvidia",
		component: NvidiaLandingPage,
		meta: {
			disallowInPosMode: true
		}
	},
	{
		path: "/streaming-bundle",
		name: "stream-build",
		component: StreamPromo,
		meta: {
			disallowInPosMode: true
		}
	},
	{
		path: "/refurbished-builds",
		name: "refurbished-builds",
		component: RefurbishedBuilds,
		meta: {
			disallowInPosMode: true
		}
	},
	{
		path: "/hue2-promo",
		name: "hue2-promo",
		component: Hue2Promo,
		meta: {
			disallowInPosMode: true
		}
	},
	{
		path: "/bld",
		name: "step1",
		component: BuildPc
	},
	{
		path: "/BLDA",
		name: "stepAf",
		component: BuildAf
	},
	{
		path: "/bld/step2",
		name: "step2",
		component: BuildPcStep2
	},
	{
		path: "/bld/step3",
		name: "step3",
		component: BuildPcStep3
	},
	{
		name: "step4",
		path: "/bld/step4",
		component: BuildPcStep4
	},
	{
		name: "step4-mobile",
		path: "/bld/step4-mobile",
		component: BuildPcStep4Mobile
	},
	{
		name: "step5",
		path: "/bld/step5",
		component: BuildPcStep5
	},
	{
		path: "/reviews",
		component: BuildReviews
	},
	{
		path: "/terms-of-service",
		beforeEnter: () => {
			location.href = "https://www.nzxt.com/terms-of-service";
		}
	},
	{
		path: "/privacy-policy",
		beforeEnter: () => {
			location.href = "https://www.nzxt.com/privacy-policy";
		}
	},
	{
		path: "/warranty",
		component: Warranty
	},
	{
		path: "/returns-and-exchanges",
		component: Returns
	},
	{
		path: "/shipping-and-deliveries",
		component: Shipping
	},
	{
		path: "/assembly-service-package",
		redirect: "/what-is-bld"
	},
	{
		path: "/what-is-bld",
		component: WhatIsBld
	},
	{
		path: "/bld-intel",
		component: BuildIntel
	},
	{
		path: "/coffeelake",
		component: BuildIntel
	},
	{
		path: "/tracking-order/:accessHash",
		component: UserTrackingOrder,
		meta: {
			disallowInPosMode: true
		}
	},
	{
		path: "/user",
		component: UserConfig,
		meta: {
			disallowInPosMode: true
		}
	},
	{
		path: "/user/login",
		component: UserLogin,
		meta: {
			disallowInPosMode: true
		}
	},
	{
		path: "/user/signup",
		component: UserSignup,
		meta: {
			disallowInPosMode: true
		}
	},
	{
		name: "forgot-password",
		path: "/user/forgot-password",
		component: UserForgotPass,
		meta: {
			disallowInPosMode: true,
			shouldNotBeLogged: true
		}
	},
	{
		name: "reset-password",
		path: "/user/reset-password/:token",
		component: UserResetPass,
		meta: {
			disallowInPosMode: true,
			shouldNotBeLogged: true
		}
	},
	{
		path: "/user/account",
		name: "UserAccount",
		component: UserAccount,
		meta: {
			disallowInPosMode: true,
			requiresAuth: true
		}
	},
	{
		path: "/users/tickets/show/:id",
		name: "TicketDetails",
		component: UserTicketDetails,
		meta: {
			disallowInPosMode: true,
			requiresAuth: true
		}
	},
	{
		path: "/BLD/shared/:build_number",
		name: "UserBuild",
		component: UserBuild,
		meta: {
			disallowInPosMode: true
		}
	},
	{
		path: "/pc-rental",
		name: "pc-rental",
		component: PCRental
	},
	{
		path: "/pc-rental/subscribe",
		name: "pc-rental-subscribe",
		component: PCRentalSubscribe
	},
	{
		path: "/starter-series",
		name: "starter-series",
		component: StaterLineSeries,
		meta: {
			group: "starter-series"
		}
	},
	{
		path: "/starter-series/accessories",
		name: "starter-accessories",
		component: PrebuildAccessoriesStore,
		meta: {
			group: "starter-series"
		}
	},
	{
		path: "/starter-series/cart",
		name: "starter-cart",
		component: PrebuildCart,
		meta: {
			group: "starter-series"
		}
	},
	{
		path: "/starter-pc",
		name: "starter-pc",
		redirect: { name: "starter-series" }
	},
	{
		path: "/starter-pc/accessories",
		name: "starter-pc-accessories",
		redirect: { name: "starter-series" }
	},
	{
		path: "/starter-pc/cart",
		name: "starter-pc-cart",
		redirect: { name: "starter-series" }
	},
	{
		path: "/starter-pc-plus",
		name: "starter-pc-plus",
		redirect: { name: "starter-series" }
	},
	{
		path: "/starter-pc-plus/accessories",
		name: "starter-pc-plus-accessories",
		redirect: { name: "starter-series" }
	},
	{
		path: "/starter-pc-plus/cart",
		name: "starter-pc-plus-cart",
		redirect: { name: "starter-series" }
	},
	{
		path: "/streaming-pc",
		name: "streaming-pc",
		component: StarterPC,
		meta: {
			group: "streamer-pc",
			starterPC: true
		}
	},
	{
		path: "/streaming-pc/accessories",
		name: "streaming-pc-accessories",
		component: AccessoriesStore,
		meta: {
			group: "streamer-pc",
			disallowInPosMode: true,
			starterPC: true
		}
	},
	{
		path: "/streaming-pc/cart",
		name: "streaming-pc-cart",
		component: StarterPcCart,
		meta: {
			group: "streamer-pc",
			disallowInPosMode: true,
			starterPC: true
		}
	},
	{
		path: "/creator-pc",
		name: "creator-pc",
		component: StarterPC,
		meta: {
			group: "creator-pc",
			starterPC: true
		}
	},
	{
		path: "/creator-pc/accessories",
		name: "creator-pc-accessories",
		component: AccessoriesStore,
		meta: {
			group: "creator-pc",
			disallowInPosMode: true,
			starterPC: true
		}
	},
	{
		path: "/creator-pc/cart",
		name: "creator-pc-cart",
		component: StarterPcCart,
		meta: {
			group: "creator-pc",
			disallowInPosMode: true,
			starterPC: true
		}
	},
	{
		path: "/h1-mini-pc",
		name: "h1-mini-pc",
		component: StarterPC,
		meta: {
			group: "h1-mini-pc",
			starterPC: true
		}
	},
	{
		path: "/h1-mini-pc/cart",
		name: "h1-mini-pc-cart",
		component: StarterPcCart,
		meta: {
			group: "h1-mini-pc",
			disallowInPosMode: true,
			starterPC: true
		}
	},
	{
		path: "/h1-mini-pc/accessories",
		name: "h1-mini-pc-accessories",
		component: AccessoriesStore,
		meta: {
			group: "h1-mini-pc",
			disallowInPosMode: true,
			starterPC: true
		}
	},
	{
		path: "*",
		name: "NotFound",
		component: NotFound
	}
];

export default routes;
